import { ForgotPasswordType } from './../../types/customAuth';
import { axiosInstance } from './index';

export const customAuthService = {
    async addCandidateLead(param: FormData) {
        await axiosInstance.post(`User/AddCandidateLead`, param);
        // return data as CustomSignUpOtpResponseType;
    },

    async addCompanyLead(param: FormData) {
        await axiosInstance.post(`User/AddCompanyLead`, param);
        // return data as CustomSignUpOtpResponseType;
    },

    async getForgotPassword(param: ForgotPasswordType) {
        await axiosInstance.post(`User/ForgotPassword`, param);
        // return data as CustomSignUpOtpResponseType;
    },
};
